import { formatTransactionMonthYear, formatTransactionShortDate } from './dateTimeUtils';

// Transaction date formatter for Asia/Kolkata local calendar values.
export const formatDate = (dateString: string): string => {
  return formatTransactionShortDate(dateString);
};

export const formatMonthYear = (dateString: string): string => {
  return formatTransactionMonthYear(dateString);
};
